import React from 'react'

import sizeMe from 'react-sizeme'

function sizeContent(props) {
  return <div>{props.children}</div>
}

export default sizeMe({monitorWidth: false, monitorHeight: true})(sizeContent)